import { Group, Rating, Text } from "@mantine/core";
import { FunctionComponent } from "react";

interface StarRatingProps {
  /** Average rating value (0-5) */
  value: number;
  /** Number of reviews */
  count?: number;
  /** Whether this is an input for setting a rating */
  readOnly?: boolean;
  /** Callback when rating changes (for input mode) */
  onChange?: (value: number) => void;
  /** Size of the stars */
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  /** Show count text */
  showCount?: boolean;
}

export const StarRating: FunctionComponent<StarRatingProps> = ({
  value,
  count,
  readOnly = true,
  onChange,
  size = "sm",
  showCount = true,
}) => {
  return (
    <Group gap="xs">
      <Rating
        value={value}
        readOnly={readOnly}
        onChange={onChange}
        size={size}
        // Only allow fractions for display (readOnly), not for input
        fractions={readOnly ? 2 : 1}
      />
      {showCount && count !== undefined && (
        <Text size={size} c="dimmed">
          ({count})
        </Text>
      )}
    </Group>
  );
};

export default StarRating;
